@if (commentable.type == 'status') {
  <div class="feed-item-footer">
    <div class="container-fluid">
      <div class="actions">
        <ut-community-feed-item-like-count [likeable]="commentable"></ut-community-feed-item-like-count>
        <ut-community-feed-item-like-btn [likeable]="commentable"></ut-community-feed-item-like-btn>
        <ut-comment-btn [commentable]="commentable"></ut-comment-btn>
      </div>
      <a
        (click)="openCommentEditor()"
        class="clickable"
        data-slide-up-trigger="singleCommentSection"
        >
        <i class="icon icon-chat"></i>Write a Comment
      </a>
    </div>
  </div>
}

<div class="section-single-comment" [ngClass]="wrapperClass" id="comment">
  <h2 class="sr-only">Comment Section</h2>
  <div class="container-fluid">
    @if (commentable.type == 'topic' && comments.length) {
      <div class="section-single-body-filter clearfix">
        <ut-custom-dropdown [options]="sortingOptions" [model]="sorting" (onChange)="sortingChanged($event)"></ut-custom-dropdown>
      </div>
    }
  </div>

  <div class="block container-fluid">
    @if (!isLoading) {
      <div>
        @if (!comments.length && search.query.length) {
          <div class="feed-loading-message">
            No results
          </div>
        }
        <!-- CommentsTitle -->
        @if (commentable.type !== 'topic') {
          <div class="clearfix mb3">
            <div class="section-single-comment-heading pull-left">
              {{paginationData.totalItems}} {{paginationData.totalItems === 1 ? 'comment' : 'comments'}}
            </div>
            <div class="pull-right">
              <ut-custom-dropdown [options]="sortingOptions" [model]="sorting" (onChange)="sortingChanged($event)"></ut-custom-dropdown>
            </div>
          </div>
        }
        <!-- CommentsTitle -->
        <!-- CommentItems -->
        @for (comment of comments; track comment; let i = $index) {
          <div
            class="section-single-comment-content feed"
            [id]="'comment_' + comment.id"
            [class.selected-comment]="comment.id == selectedComment">
            @if ((commentable.type != 'topic' || (commentable.type == 'topic' && commentable.content != comment.content) || (commentable.type == 'topic' && commentable.content == comment.content && commentable.user.id != comment.user.id))) {
              <div
                class="indent"
                [ngClass]="'indent-' + comment.indentation"
                >
                <div class="feed-header clearfix">
                  <a class="feed-header-info" [uiSref]="'profile.about'" [uiParams]="{profileId: comment.user.slug}" [attr.aria-label]="'Comment Author, ' + comment.user.name + ', ' + (comment.published_at | relativeDate)">
                    <div class="feed-header-info-icon">
                      <ut-avatar-badges [user]="comment.user"></ut-avatar-badges>
                    </div>
                    <div class="feed-header-info-name">
                      <span class="feed-header-info-name__text">{{comment.user.name}}
                        @if (comment.user.country?.name) {
                          <span>({{comment.user.country.name}})</span>
                        }</span>
                        @if (comment.user.user_title) {
                          <div class="feed-item-header-title comment-header-title">{{comment.user.user_title | strLimit:50}}</div>
                        }
                        <span class="time-stamp">{{comment.published_at | relativeDate}}</span>
                      </div>
                    </a>
                    <div class="func-btns" [ngClass]="{'deleted': deletingCommentId === comment.id}">
                      <div class="main-btns">
                        @if (comment.current_user_permissions.destroy) {
                          <button
                            id="deleteCommentBtn"
                            class="btn btn-rounded small btn-outline delete-button"
                            (click)="deletingCommentId = comment.id;focusBtn('delete')"
                          aria-hidden="false">Delete</button>
                        }
                        @if (comment.current_user_permissions.update) {
                        &ngsp;<button
                          id="editCommentBtn"
                          (click)="openCommentEditor(comment)"
                          class="btn small btn-outline btn-rounded edit-button"
                          data-slide-up-trigger="singleCommentSection"
                        [attr.aria-hidden]="deletingCommentId === comment.id">Edit</button>
                      }
                    </div>
                    @if (comment.current_user_permissions.destroy) {
                      <div class="delete-confirmation">
                        Are you sure?
                        <button
                          id="deleteCommentBtnNo"
                          class="btn btn-rounded small delete-button"
                          (click)="deletingCommentId = null;focusBtn('no')"
                          (keydown)="handleKeydownDeleteConformation($event)"
                          aria-hidden="true"
                          aria-label="Are you sure you want to delete?, No"
                          [tabindex]="deletingCommentId === comment.id ? 0 : -1"><div>No</div></button>
                          &ngsp;<button
                          id="deleteCommentBtnYes"
                          class="btn btn-rounded small delete-button"
                          (click)="deleteComment(comment.id)"
                          (keydown)="handleKeydownDeleteConformation($event)"
                          [attr.aria-hidden]="deletingCommentId !== comment.id"
                          aria-label="Are you sure you want to delete?, Yes, Delete"
                          [tabindex]="deletingCommentId === comment.id ? 0 : -1"><div>Yes, Delete</div></button>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="feed-content">
                    @if (comment.rating !== undefined && comment.rating >= 0) {
                      <div class="rating">
                        <ut-star-rating [rating]="comment.rating" [max]="5" [readonly]="true"></ut-star-rating>
                      </div>
                    }
                    <article [innerHTML]="comment.content_built"></article>
                    @if (commentable.type !== 'topic' && commentable.current_user_permissions.comment) {
                      <a
                        class="feed-content__reply-link"
                        href="#"
                        [id]="'reply_' + i"
                        tabindex="0"
                        (click)="replyFocusIndex = i;openCommentEditor({parent_id:comment.id, reply_index: i, content: '@' + comment.user.slug + ' '})"
                        data-slide-up-trigger="singleCommentSection">
                        <i class="icon icon-reply"></i>Reply
                      </a>
                    }
                    <div class="func-btns">
                      <ut-community-feed-item-hide [item]="comment"></ut-community-feed-item-hide>
                      @if (commentable.current_user_permissions.comment && commentable.type == 'topic') {
                        <span
                          class="clickable"
                          (click)="openCommentEditor(comment, 'quote')"
                          data-slide-up-trigger="singleCommentSection">
                          <i class="material-icons format-quote-icon">format_quote</i>
                        </span>
                      }
                      <ut-community-feed-item-like-count [likeable]="comment"></ut-community-feed-item-like-count>
                      <ut-community-feed-item-like-btn [likeable]="comment"></ut-community-feed-item-like-btn>
                      <ut-community-feed-item-flag [item]="comment"></ut-community-feed-item-flag>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          <!-- CommentItems -->
          <!-- CommentPagination -->
          <ut-feed-paginator [paginationData]="paginationData" (loadPage)="loadPage($event)"></ut-feed-paginator>
          <!-- /CommentPagination -->
        </div>
      }
      @if (isLoading) {
        <ut-loading-dots></ut-loading-dots>
      }
    </div>

    <!-- Write a comment Button -->
    @if (commentable.current_user_permissions.comment && !isLoading && !commentable.locked) {
      <div class="block container-fluid">
        <div class="comment-btn">
          <a [innerHTML]="commentBtnLabel" href="#" class="btn btn-blue" data-slide-up-trigger="singleCommentSection" (click)="openCommentEditor() && broadcastOpening()"></a>
        </div>
      </div>
    }
    @if (!currentUser && !isLoading && !commentable.locked) {
      <div class="block container-fluid">
        <div class="comment-btn">
          <a [innerHTML]="commentBtnLabel" [href]="loginUrl" target="_self" class="btn btn-filled btn-rounded small"></a>
        </div>
      </div>
    }
    <!-- /Write a comment Button -->

    <!-- Write a comment Form -->
    <section [ngClass]="commentable.type" class="slide-up slide-up-move comment-form" id="singleCommentSection" [utSlideUp]="'singleCommentSection'">
      <button class="slide-up-close" (click)="closeCommentForm()" aria-label="Close">
        <i class="material-icons" aria-hidden="true">close</i>
      </button>
      <div class="slide-up-content">
        <form (ngSubmit)="submitComment()">
          <div class="comment-form-rating">
            <h4>Your Rating:</h4>
            <div class="rating clickable">
              <ut-star-rating [(rating)]="newComment.rating" [max]="5" [readonly]="false"></ut-star-rating>
            </div>
          </div>
          <div class="comment-form-reply">
            <label for="slideUpTextArea">{{ newComment.id ? 'Edit' : 'Write' }} your Reply:</label>
            <ut-editor [(value)]="newComment.content" text-area-label="Write your reply here"></ut-editor>
          </div>
          <div class="comment-form-btn">
            <button type="submit" class="btn slide-up-submit">Submit</button>
          </div>
        </form>
      </div>

    </section>
    <!-- /Write a comment Form -->
  </div>
